const CampaignReportsActionTypes = Object.freeze({
  FETCH_CAMPAIGN_GIFT_REPORTS_START: 'reports/FETCH_CAMPAIGN_GIFT_REPORTS_START',
  FETCH_CAMPAIGN_GIFT_REPORTS_SUCCESS: 'reports/FETCH_CAMPAIGN_GIFT_REPORTS_SUCCESS',
  FETCH_CAMPAIGN_GIFT_REPORTS_FAILURE: 'reports/FETCH_CAMPAIGN_GIFT_REPORTS_FAILURE',
  SET_CAMPAIGN_REPORTS_STATE: 'reports/SET_CAMPAIGN_REPORTS_STATE',
  FETCH_GIFT_WINNERS_START: 'reports/FETCH_GIFT_WINNERS_START',
  FETCH_GIFT_WINNERS_SUCCESS: 'reports/FETCH_GIFT_WINNERS_SUCCESS',
  EXPORT_COUPONS_START: 'reports/EXPORT_COUPONS_START',
});

export default CampaignReportsActionTypes;
